(function () {
  const script = document.currentScript;
  const scopeSelector = script?.dataset.weightScope || 'body';

  const regex = /\b(?:2|3|5)\s+kg\b/gi;

  function processTextNode(node) {
    const parent = node.parentElement;

    if (
      !parent ||
      parent.closest('.highlight-weight') ||
      ['SCRIPT', 'STYLE', 'TEXTAREA', 'NOSCRIPT'].includes(parent.tagName)
    ) {
      return;
    }

    const text = node.nodeValue;

    regex.lastIndex = 0;

    if (!regex.test(text)) {
      return;
    }

    regex.lastIndex = 0;

    const fragment = document.createDocumentFragment();
    let lastIndex = 0;

    text.replace(regex, function (match, offset) {
      fragment.appendChild(
        document.createTextNode(text.slice(lastIndex, offset))
      );

      const span = document.createElement('span');
      span.className = 'highlight-weight';
      span.textContent = match;

      fragment.appendChild(span);

      lastIndex = offset + match.length;

      return match;
    });

    fragment.appendChild(
      document.createTextNode(text.slice(lastIndex))
    );

    node.replaceWith(fragment);
  }

  function processElement(root) {
    if (!root) return;

    if (root.nodeType === Node.TEXT_NODE) {
      processTextNode(root);
      return;
    }

    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT
    );

    const nodes = [];

    while (walker.nextNode()) {
      nodes.push(walker.currentNode);
    }

    nodes.forEach(processTextNode);
  }

  function processScopes() {
    document
      .querySelectorAll(scopeSelector)
      .forEach(processElement);
  }

  function init() {
    // Premier traitement
    processScopes();

    // Pour le contenu éventuellement ajouté dynamiquement
    const observer = new MutationObserver(function (mutations) {
      for (const mutation of mutations) {
        for (const node of mutation.addedNodes) {
          if (node.nodeType !== Node.ELEMENT_NODE) continue;

          // Collection : body entier
          if (scopeSelector === 'body') {
            processElement(node);
            continue;
          }

          // Produit : uniquement les H1
          if (node.matches?.(scopeSelector)) {
            processElement(node);
          }

          node
            .querySelectorAll?.(scopeSelector)
            .forEach(processElement);

          // Modification interne d'un H1 existant
          const parentScope = node.closest?.(scopeSelector);

          if (parentScope) {
            processElement(parentScope);
          }
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();